import { formatCurrency } from "util/format";

export const ColumnsMonthCashFlowWithoutBudget = [
  {
    title: "Cliente",
    dataIndex: "client",
    textWrap: "word-break",
    ellipsis: true,
  },
];
export const ColumnsMonthCashFlowExpendWithoutBudget = (data) => {
  let months = replaceMonth(data);
  const columns = [];
  let width = "14%";

  switch (months.length) {
    case 1:
      width = "40%";
      break;
    case 2:
      width = "40%";
      break;
    case 3:
      width = "20%";
      break;
    case 4:
      width = "20%";
      break;
    case 5:
      width = "20%";
      break;
    case 6:
      width = "20%";
      break;
    case 7:
      width = "18%";
      break;
    case 8:
      width = "18%";
      break;
    case 9:
      width = "18%";
      break;
    case 10:
      width = "15%";
      break;
    case 11:
      width = "15%";
      break;
    case 12:
      width = "15%";
      break;
    default:
      break;
  }

  columns.push({
    title: <div style={{ textAlign: "center" }}>Grupo</div>,
    dataIndex: "name",
    responsive: ["sm"],
    width: width,
    fixed: "left",
    textWrap: "word-break",
    ellipsis: true,
    render(text, record) {
      let color = record.isDad ? "#BABBC2" : "";
      let margin = record.isDad ? "0px" : "10px";
      let fontWeight = record.isDad ? "bold" : "initial";
      if (record.categoryType == "REVENUE") {
        if (record.isDad) {
          color = "#BABBC2";
        }
      } else {
        if (record.isDad) {
          color = "#BABBC2";
        }
      }
      if (record.mapping && record.mapping.length == 0) {
        color = "#98A5AC";
      }
      if (record.order == 0 || record.order == 9999) {
        color = "#98A5AC";
      }
      let func = record.isDad ? () => {} : record.showDetails;

      return {
        props: {
          style: { background: color },
        },
        children: (
          <div
            style={{
              marginLeft: margin,
              fontWeight: fontWeight,
              cursor: "pointer",
            }}
            onClick={() => func("total", record, "Total")}
          >
            {text}
          </div>
        ),
      };
    },
  });
  if (months) {
    months.forEach((element) => {
      columns.push({
        title: <div style={{ textAlign: "center" }}>{element.name}</div>,
        children: [
          {
            title: <div style={{ textAlign: "center" }}>Realizado</div>,
            dataIndex: "amount",
            textWrap: "word-break",
            ellipsis: true,
            responsive: ["sm"],
            render(text, record) {
              let value = 0;
              record.amountMonth.forEach((item) => {
                let keyMonth = item.month.substring(0, 3);
                if (keyMonth == element.key) {
                  value = item.profit;
                }
              });
              let color = record.isDad ? "#BABBC2" : "";

              let fontWeight = record.isDad ? "bold" : "initial";
              if (record.categoryType == "REVENUE" && record.isDad) {
                color = "#BABBC2";
              } else if (record.categoryType == "EXPENSE" && record.isDad) {
                color = "#BABBC2";
              }
              if (record.mapping && record.mapping.length == 0) {
                color = "#98A5AC";
              }
              if (record.order == 0 || record.order == 9999) {
                color = "#98A5AC";
              }
              let func = record.isDad ? () => {} : record.showDetails;
              return {
                props: {
                  style: { background: color },
                },
                children: (
                  <div
                    style={{
                      textAlign: "end",
                      fontWeight: fontWeight,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      func(getKeyMonth(element.name), record, element.name)
                    }
                  >
                    {formatCurrency(value)}
                  </div>
                ),
              };
            },
          },
        ],
      });
    });
  }

  columns.push({
    title: <div style={{ textAlign: "center" }}>Total</div>,

    children: [
      {
        title: <div style={{ textAlign: "center" }}>Realizado</div>,
        dataIndex: "amountMonths",
        responsive: ["sm"],
        textWrap: "word-break",
        ellipsis: true,
        render(text, record) {
          let color = record.isDad ? "#BABBC2" : "";
          let fontWeight = record.isDad ? "bold" : "initial";

          if (record.categoryType == "REVENUE" && record.isDad) {
            color = "#BABBC2";
          } else if (record.categoryType == "EXPENSE" && record.isDad) {
            color = "#BABBC2";
          }
          if (record.mapping && record.mapping.length == 0) {
            color = "#98A5AC";
          }
          if (record.order == 0 || record.order == 9999) {
            color = "#98A5AC";
          }
          let func = record.isDad ? () => {} : record.showDetails;

          return {
            props: {
              style: { background: color },
            },
            children: (
              <div
                style={{
                  textAlign: "end",
                  fontWeight: fontWeight,
                  cursor: "pointer",
                }}
                onClick={() => func("total", record, "Total")}
              >
                {formatCurrency(text)}
              </div>
            ),
          };
        },
      },
    ],
  });

  return columns;
};
export const ColumnsMonthCashFlowCategoryExpendWithoutBudget = (data) => {
  let months = replaceMonth(data);

  const columns = [];
  let width = "20%";
  if (data.length == 1) {
    width = "30%";
  } else if (data.length == 2) {
    width = "30%";
  } else if (data.length == 3) {
    width = "30%";
  } else if (data.length == 4) {
    width = "30%";
  } else if (data.length == 5) {
    width = "25%";
  } else if (data.length == 6) {
    width = "25%";
  } else if (data.length == 7) {
    width = "20%";
  } else if (data.length == 8) {
    width = "15%";
  } else if (data.length == 9) {
    width = "15%";
  } else if (data.length == 10) {
    width = "15%";
  } else if (data.length == 11) {
    width = "15%";
  } else if (data.length == 12) {
    width = "15%";
  }

  columns.push({
    title: "Categoria",
    dataIndex: "category",
    width: width,
    responsive: ["sm"],
    fixed: "left",
    textWrap: "word-break",
    ellipsis: true,
    render: (text) => {
      return <div style={{ marginLeft: "10px" }}>{text}</div>;
    },
  });

  if (months) {
    months.forEach((element) => {
      columns.push({
        title: <div>{element.name}</div>,
        textWrap: "word-break",
        ellipsis: true,
        responsive: ["sm"],
        children: [
          {
            title: "Realizado",
            dataIndex: "amount",
            textWrap: "word-break",
            ellipsis: true,
            responsive: ["sm"],
            render(text, record) {
              let value = 0;
              record.amountMonth.forEach((item) => {
                let keyMonth = item.month.substring(0, 3);
                if (keyMonth == element.key) {
                  value = item.profit;
                }
              });
              return (
                <div style={{ textAlign: "end" }}>{formatCurrency(value)}</div>
              );
            },
          },
        ],
      });
    });
  }

  columns.push({
    title: <div style={{ textAlign: "center" }}>Total</div>,
    children: [
      {
        title: "Realizado",
        dataIndex: "amountMonths",
        responsive: ["sm"],
        textWrap: "word-break",
        ellipsis: true,
        render(text, record) {
          return (
            <div style={{ textAlign: "center" }}>{formatCurrency(text)}</div>
          );
        },
      },
    ],
  });

  return columns;
};

function replaceMonth(month) {
  const newMonth = [];
  if (month) {
    month.forEach((monthItem) => {
      var name = monthItem.trim();
      name = name.replace("JANUARY", "Janeiro");
      name = name.replace("FEBRUARY", "Fevereiro");
      name = name.replace("MARCH", "Março");
      name = name.replace("APRIL", "Abril");
      name = name.replace("MAY", "Maio");
      name = name.replace("JUNE", "Junho");
      name = name.replace("JULY", "Julho");
      name = name.replace("AUGUST", "Agosto");
      name = name.replace("SEPTEMBER", "Setembro");
      name = name.replace("OCTOBER", "Outubro");
      name = name.replace("NOVEMBER", "Novembro");
      name = name.replace("DECEMBER", "Dezembro");
      let order = 0;
      switch (name) {
        case "Janeiro":
          order = 1;
          break;
        case "Fevereiro":
          order = 2;
          break;
        case "Março":
          order = 3;
          break;
        case "Abril":
          order = 4;
          break;
        case "Maio":
          order = 5;
          break;
        case "Junho":
          order = 6;
          break;
        case "Julho":
          order = 7;
          break;
        case "Agosto":
          order = 8;
          break;
        case "Setembro":
          order = 9;
          break;
        case "Outubro":
          order = 10;
          break;
        case "Novembro":
          order = 11;
          break;
        case "Dezembro":
          order = 12;
          break;

        default:
          break;
      }
      newMonth.push({
        name: name,
        order: order,
        key: monthItem.substring(0, 3),
      });
    });
  }
  let monthOrder = newMonth.sort(compareNumbers);

  return monthOrder;
}

function compareNumbers(a, b) {
  return a.order - b.order;
}

function getKeyMonth(month) {
  let key = 0;
  switch (month) {
    case "Janeiro":
      key = "01";
      break;
    case "Fevereiro":
      key = "02";
      break;
    case "Março":
      key = "03";
      break;
    case "Abril":
      key = "04";
      break;
    case "Maio":
      key = "05";
      break;
    case "Junho":
      key = "06";
      break;
    case "Julho":
      key = "07";
      break;
    case "Agosto":
      key = "08";
      break;
    case "Setembro":
      key = "09";
      break;
    case "Outubro":
      key = "10";
      break;
    case "Novembro":
      key = "11";
      break;
    case "Dezembro":
      key = "12";
      break;

    default:
      key = "total";
      break;
  }

  return key;
}
